$(function(){
    //显示下拉框
    $("body").on('click','.drop-down .btn,.report-drop .report-btn',function(event){
        if($(this).hasClass('report-btn')){
            $(this).parent().siblings('.report-drop').removeClass('open');
        }
        if($(this).parent().hasClass('open')){
            $(this).parent().removeClass('open');
        }else{
            $(".drop-down").removeClass('open');
            $(this).parent().addClass('open');
        }
        event.stopPropagation();
    })
    //点击下拉选项
    $("body").on('click','.drop-down .option li,.report-down',function(event){
        event.stopPropagation();
        if($(this).hasClass('repTem')){
            $(this).parents('.drop-down').removeClass('open');
            return;
        }
        if($(this).hasClass('disabled')){
            return;
        }
        $(this).parents('.drop-down').removeClass('open');
        let val = $(this).text();
        $(this).parents('.drop-down').find('.btn .text').text(val);
    })
    $("body").on('click',function(){
        $(".drop-down,.report-drop").removeClass('open');
    })
    $("body").on('click','.eventChannelText',function(event){
        $(this).next().removeClass('hide');
        event.stopPropagation();
    })
    $("body").on('click',function(){
        $(".eventChannelTit").addClass('hide');
    })
})

// import api from '../api/index.js'
import api from '@/api/index.js'
import router from '@/router'
export default {
    data() {
        return {
            aletrTimer:''
        }
    },
    // 时间转化
    dateConversion (date,type) {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        let day = date.getDate();
        day = day < 10 ? '0' + day : day;
        let hour = date.getHours();
        hour = hour < 10 ? '0' + hour : hour;
        let minute = date.getMinutes();
        minute = minute < 10 ? '0' + minute : minute;
        let miao = date.getSeconds();
        miao = miao < 10 ? '0' + miao : miao;
        if(type == 0){//年月日
            return year + '-' + month + '-' + day;
        }else if(type == 1){//年月日时分
            return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':'+ miao;
        }
        
    },
    alertText (text,width,time) {
        $(".alertText").remove();
        clearTimeout(this.aletrTimer);
        let html = '<div class="alertText ac" style="width:'+width+'px;"><div class="in">'+text+'</div></div>';
        $("body").append(html);
        if(time == undefined){
            time = 2000;
        }
        this.aletrTimer = setTimeout(() => {
            $(".alertText").remove();
        }, time);
    },
    //计算时间跨度
    getDateDiff(startDate,endDate){  
        let startTime = new Date(Date.parse(startDate.replace(/-/g,   "/"))).getTime();     
        let endTime = new Date(Date.parse(endDate.replace(/-/g,   "/"))).getTime();     
        let dates = Math.abs((startTime - endTime))/(1000*60*60*24);     
        return  dates;    
    },
    // 检测数组位置
    indexOf(arr, str){
        // 如果可以的话，调用原生方法
        if(arr && arr.indexOf){
            return arr.indexOf(str);
        }
         
        let len = arr.length;
        for(let i = 0; i < len; i++){
            // 定位该元素位置
            if(arr[i] == str){
                return i;
            }
        }
         
        // 数组中不存在该元素
        return -1;
    },
    // 获取当前时间
    getNowDate(type) {//获取当前时间
        let date = new Date();
        let seperator1 = "-";
        let seperator2 = ":";
        let month = date.getMonth() + 1<10? "0"+(date.getMonth() + 1):date.getMonth() + 1;
        let strDate = date.getDate()<10? "0" + date.getDate():date.getDate();
        let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        let currentdate = '';
        if(type === 0){//不带时分秒
            currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate
        }else{//带时分秒
            currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate
            + " "  + h  + seperator2  + m
            + seperator2 + s;
        }
        return currentdate;
    },
    // 获取当前时间前的时间 天数自定义
    getBeforeDay(date,num,type){
        var date = date || new Date(),
            timestamp, 
            newDate;
        if(!(date instanceof Date)){
            date = new Date(date.replace(/-/g, '/'));
        }
        timestamp = date.getTime();
        newDate = new Date(timestamp - num * 24 * 3600 * 1000);
        let month = newDate.getMonth() + 1;
        month = month.toString().length == 1 ? '0' + month : month; 
        let day = newDate.getDate().toString().length == 1 ? '0' + newDate.getDate() :newDate.getDate();
        let dates = '';
        if(type === 1){//不带时分秒
            let hour = newDate.getHours().toString().length == 1 ? '0' + newDate.getHours() : newDate.getHours();
            let minute = newDate.getMinutes().toString().length == 1 ? '0' + newDate.getMinutes() : newDate.getMinutes();
            let second = newDate.getSeconds().toString().length == 1 ? '0' + newDate.getSeconds() : newDate.getSeconds();
            dates = [newDate.getFullYear(), month, day].join('-') + ' ' + [hour, minute, second].join(':');
        }else{
            dates = [newDate.getFullYear(), month, day].join('-');
        }
        return dates;
    },
    // 返回当前和自定义时间
    returnTimeRange (type,num){
        let nowDate = this.getNowDate(type);
        let maxDate = this.getBeforeDay(nowDate,num,type);
        return [nowDate,maxDate]
    },
    // 时间转化毫秒
    dateToMillisecond (str) {
        let arr = str.split(/[- : \/]/);
        let date = Date.parse(new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]));
        return date;
    },
    // 计算
    getWeek(i,time) {
        let now = new Date();
        let miao1 = now.getHours()*3600 + now.getMinutes()*60;
        time = time.split(':');
        let miao2 = parseInt(time[0])*3600 + parseInt(time[1])*60;
        let currWeek = now.getDay() - 1;
        
        if((i <= currWeek && miao1 > miao2)||(i < currWeek)){
            i = 7-(currWeek - i);
        }else{
            i = i-currWeek
        }
        let firstDay=now;
        firstDay.setDate(firstDay.getDate() + i);
        let mon = Number(firstDay.getMonth()) + 1;
        mon = mon.toString().length == 1 ? '0' + mon : mon;
        let day = firstDay.getDate().toString().length == 1 ? '0' + firstDay.getDate() :firstDay.getDate(); 
        return now.getFullYear() + "-" + mon + "-" + day;
    },
    // 存cookie 单位天
    saveCookie(cookieName,cookieValue,cookieDates){
        var d = new Date();
        d.setDate(d.getDate()+cookieDates);
        document.cookie = cookieName+"="+cookieValue+";expires="+d.toGMTString();
    }, 
    // 取cookie
    getCookie(cookieName){
        var cookieStr = unescape(document.cookie);
        var arr = cookieStr.split("; ");
        var cookieValue = "";
        for(var i=0;i<arr.length;i++){
            var temp = arr[i].split("=");
            if(temp[0]==cookieName){
                cookieValue = temp[1];
                break;
            }
        }
        return cookieValue;
    },
    // 删除cookie
    removeCookie(cookieName) {
        this.saveCookie(cookieName,'',-1);
    },
	// code判断
	returnCode (data,callback,catchBack) {
		let code = data.code;
		let host = window.location.host;
		let realmName = 'http://' + host + '/';
		if(code === 10000){
			callback();
		}else{
			if(code === 10004){//会员过期
				if($('.alertText').length <= 0){
					this.alertText('会员已过期，请购买会员');
                    router.push({ path:'/vipRight'});
				}
                document.getElementById('loadBox').style.display = 'none'
				//window.location.href=""+realmName+"vipRight";
				
			}else if(code === 10003){//未登录
				window.location.href=""+realmName+"";
				this.removeCookie('xiaohuozi')
				// this.$router.push({ path:'/'});
			}else{
				if(data.msg != undefined){
					this.alertText(data.msg);
				}
            }
		}
	},
	//获取下载关键词
	getDownloadBefore(data,callback,matchBack){
		let that = this;
		api.post('monitor/info/download-before',data,r =>{
            matchBack();
			that.returnCode(r,function(){
				callback(r);
            })
		})
	},
    // 随机颜色
    getRandomColor(){
        return '#'+Math.floor(Math.random()*16777215).toString(16);
    },
    // 生产关系图数组
    makeChartData (data){
        let nodes = [];
        let links = [];
        if(data.length>0){
            for(let i of data){
                let item1 = {
                    category: i.level,
                    nodeId: i.id,
                    draggable: true,
                    itemStyle: {
                        color:this.getRandomColor()
                    },
                    name: i.name,
                    label: {
                        show: true
                    }
                };
                let item2 = {
                    source: i.source,
                    target: i.target,
                    value: i.desc,
                    label: {
                        show: true,
                        color:'#999'
                    
                    },
                    lineStyle:{
                        width:2
                    }
                }
                nodes.push(item1)
                if(i.level != 0){
                    links.push(item2);
                }
            }
        }
        let nodeJson = {
            nodes:nodes,
            links:links
        }
        return nodeJson;
    },
    //数组转换新的键值对象
    changeArr(arr){
        let obj= Object.create(null);
        if(arr.length>0){
            let medtaObj = new Map();
            for(let item of arr){
                if(medtaObj.has(item[0])){
                    medtaObj.set(item[0],medtaObj.get(item[0]).concat(item[1]));
                }else{
                    medtaObj.set(item[0], [item[1]]);
                }
            }
            for (let[k,v] of medtaObj) {
                obj[k] = v;
            }
        }else{
            obj = ''
        }
        return obj;  
    }
}


// WEBPACK FOOTER //
// ./src/utils/index.js